var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DashboardCard',{attrs:{"width":_vm.width,"dataDisplay":_vm.dataDisplay,"dataValueFormatFilter":"currency","main_icon":_vm.main_icon,"icons":_vm.icon_data,"load_url":_vm.load_url,"title":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }